export enum ContactActions {
  IMPORT_CONTACTS = 'IMPORT_CONTACTS',
  ADD_CONTACTS = 'ADD_CONTACTS',
  EDIT_CONTACTS = 'EDIT_CONTACTS',
  VIEW_CONTACTS = 'VIEW_CONTACTS',
}

export default ContactActions;
